import React, { Component } from 'react';
import {Layout, Table} from 'antd';
import { FormattedMessage, FormattedHTMLMessage,   injectIntl } from 'react-intl';
import GuideNav from '../../components/navigation/GuideNav';
import Headline from '../../components/Headline';

const { Content } = Layout;
const imgColumns = [{
  dataIndex: 'image'
}, {
  title: <FormattedMessage id="Guide.howToUse.createPkgRequirement.imageTable.numberTitle" defaultMessage="Number"/>,
  dataIndex: 'number'
},{
  title: <FormattedMessage id="Guide.howToUse.createPkgRequirement.imageTable.sizeTitle" defaultMessage="Size(px)"/>,
  dataIndex: 'size'
}];
const imgData = [{
  key:'1',
  image : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.pkgImg" defaultMessage="<strong>Package Image</strong>"/>,
  number : <FormattedMessage id="Guide.howToUse.createPkgRequirement.imageTable.pkgImg.number" defaultMessage="One"/>,
  size: <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.pkgImg.size" defaultMessage="250x250(px) PNG file with 72dpi resolution,<br/> less than 500KB"/>
},{
  key:'2',
  image : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.stickerImg" defaultMessage="<strong>Sticker Image</strong>"/>,
  number : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.stickerImg.number" defaultMessage="At least one, no maximum<br/>number of images"/>,
  size: <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.stickerImg.size" defaultMessage="618x618(px) PNG file or GIF file<br/>referring to the Production Guide page <br/>with 72dpi resolution, less than 500KB"/>
}];

const textColumns = [{
  dataIndex: 'text',
}, {
  title: <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.languageTitle" defaultMessage="Language"/>,
  dataIndex: 'language',
},{
  title: <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.charactersTitle" defaultMessage="The number of characters"/>,
  dataIndex: 'characters',
}];
const textData = [{
  key:'1',
  text : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgName" defaultMessage="<strong>Package Name</strong>"/>,
  language : <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgName.language" defaultMessage="English required, local language selected"/>,
  characters: <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgName.characters" defaultMessage="No maximum number of characters"/>
},{
  key:'2',
  text : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgDescription" defaultMessage="<strong>Package Description</strong>"/>,
  language : <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgDescription.language" defaultMessage="No Language Restrictions"/>,
  characters: <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgDescription.characters" defaultMessage="No maximum number of characters"/>
}];
class HowToUse extends Component{

  render(){
    const language = this.props.intl.locale;
    return (
      <div>
      <Layout style={{ background: '#fff' }}>
        <GuideNav selectedKey={"howToUse"}/>
        <Content style={{margin:20}}>
          <Headline id="Guide.howToUse.headline" defaultMessage="How to use"/>
          <div style={{margin:25}}>

            <p className="how-to-use-sub-title" id="createPackage">
              <FormattedMessage
                id={'Guide.howToUse.subTitle.1'}
                defaultMessage={'1. Click ‘Upload’ on menu.'}
              />
            </p>

            <img src={require('../../img/guide/how_to_use/howtouse_01.png').default} className="how-to-use-img" alt="how-to-use-img-01"/>

            <p className="how-to-use-sub-title" id="createPackage">
              <FormattedMessage
                id={'Guide.howToUse.subTitle.2'}
                defaultMessage={'2. Create your package.'}
              />
            </p>

            <img src={require(`../../img/guide/how_to_use/howtouse_02_${language}.png`).default} style={{width: '100%', margin: '20px auto 30px auto'}} alt=""/>

            <p style={{fontSize: 16, color: '#000'}}>
              <FormattedMessage
                id="Guide.howToUse.createPkgRequirement.title" 
                defaultMessage="⚠️ Minimum requirements for package creation"
              />
            </p>

            <p style={{fontSize:14, color :'#4a4a4a'}}>
              <FormattedHTMLMessage
                id="Guide.howToUse.createPkgRequirement.title.image" 
                defaultMessage="<strong>- Image</strong>"
              />
            </p>

            <Table
              columns={imgColumns}
              dataSource={imgData}
              pagination={false}
              className="how-to-use-table"
            />

            <p style={{marginTop:15,  fontSize:14, color :'#4a4a4a'}}>
              <FormattedHTMLMessage
                id="Guide.howToUse.createPkgRequirement.textTable" 
                defaultMessage="<strong>- Text</strong>"
              />
            </p>


            <Table
              columns={textColumns}
              dataSource={textData}
              pagination={false}
              className="how-to-use-table"
            />

            <p
            className="how-to-use-sub-title" id="selectFile">
              <FormattedMessage
                id={'Guide.howToUse.subTitle.3'}
                defaultMessage={'3. Upload the stickers that will go in your package.'}
              />
            </p>
            <img src={require(`../../img/guide/how_to_use/howtouse_03_${language}.png`).default} className="how-to-use-img" alt=""/>
            <p className="how-to-use-sub-title" id="afterUpload">
              <FormattedMessage
                id={'Guide.howToUse.subTitle.4'}
                defaultMessage={'4. Select tags and language for your uploaded sticker.'}
              />
            </p>
            <img src={require(`../../img/guide/how_to_use/howtouse_04_${language}.png`).default} className="how-to-use-img" alt=""/>
            <p className="how-to-use-sub-title" id="afterUpload">
              <FormattedMessage
                id="Guide.howToUse.subTitle.5"
                defaultMessage="5. After all stickers have been tagged, please click on 'Submit for review' to complete the process!"
              />
            </p>
            <img src={require(`../../img/guide/how_to_use/howtouse_05_${language}.png`).default} className="how-to-use-img" alt="" style={{marginBottom:80}}/>
          </div>
        </Content>
      </Layout>
      </div>
    );
  }

}

  
HowToUse = injectIntl(HowToUse);
export default HowToUse;
